import {
    TimelineLite,
    Power4,
} from 'gsap';

import Bg from '../../assets/images/example2.jpg';
import BgBack from '../../assets/images/example.png';
import BgBackMouse from '../../assets/images/gradient_small.png';
import Gradient from '../../assets/images/gradient.png';
import WindowExists from '../../utils/windowExists';

export default class PixiManager {
    constructor(
        pixi,
        displacementFilter,
        shockwaveFilter,
        dataSlider,
        lang
    ) {
        if (!WindowExists()) {
            // In case Window does not exists
            return false;
        }

        const vw = window.innerWidth;
        const vh = window.innerHeight < 820 && window.innerWidth > 1200 ? 920 : window.innerHeight;
        this.pixi = pixi;
        this.DisplacementFilter = displacementFilter;
        this.ShockwaveFilter = shockwaveFilter;
        this.lang = lang;
        this.imagesContainerArray = [];

        this.app = new this.pixi.Application({
            width: vw,
            height: vh,
            backgroundColor: 0xFFFFFF,
            resolution: 2,
            autoResize: true,
        });

        this.handleResizeFunc = this.handleResize.bind(this);
        this._bindings();

        this.dataSlider = dataSlider;
        this.posX = window.innerWidth / 2;
        this.posY = window.innerHeight / 2;
        this.sliders = [];
        this.intensity = 0;
        this.currIndex = 0;
        this.isRunning = false;
        this.text = null;
        this.gradientOverlay = null;
        this.running = true;
    }

    handleResize() {
        if ( this.app && this.app.renderer ) {
            const vh = window.innerHeight < 820 && window.innerWidth > 1200 ? 920 : window.innerHeight;
            const heroHeight = document.querySelector('.wrapper-container').getBoundingClientRect().height;

            const vw = window.innerWidth / 2;
            const sizesText = {
                '1600px': [150, 135, (vw - 675)],
                '1200px': [130, 117, (vw - 525)],
                '600px': [92, 80, 57],
                'default': [50, 54, 15],
            };

            let currentViewport = 'default';
            if (window.innerWidth > 600) {
                currentViewport = '600px';
            }
            if (window.innerWidth > 1200) {
                currentViewport = '1200px';
            }
            if (window.innerWidth > 1600) {
                currentViewport = '1600px';
            }

            if ( this.text && window.innerWidth > 1200 ) {
                this.app.renderer.resize(window.innerWidth, vh);
                this.text.style.fontSize = sizesText[currentViewport][0];
                this.text.style.lineHeight = sizesText[currentViewport][1];
                this.text.position.set(sizesText[currentViewport][2], (vh * 0.55) - (heroHeight / 2) - 35);
            } else if ( this.text && window.innerWidth > 600 ) {
                this.app.renderer.resize(window.innerWidth, window.innerHeight);
                this.text.style.fontSize = sizesText[currentViewport][0];
                this.text.style.lineHeight = sizesText[currentViewport][1];
                this.text.position.set(55, (window.innerHeight / 2) - (heroHeight / 2) - 35);
            } else if ( this.text ) {
                this.app.renderer.resize(window.innerWidth, window.innerHeight);
                this.text.style.fontSize = sizesText[currentViewport][0];
                this.text.style.lineHeight = sizesText[currentViewport][1];
                this.text.position.set(15, (window.innerHeight / 2) - (heroHeight / 2) - 35);
            }

            this.text.updateText();

            for (let i = 0; i < this.imagesContainerArray.length; i++ ) {
                this._applyFullscreen(this.imagesContainerArray[i]);
            }

            if (this.gradientOverlay) {
                this.gradientOverlay.width = window.innerWidth * 2;
                this.gradientOverlay.height = vh * 2;
                this.gradientOverlay.position.set(0,0);
            }
        }
    }

    _bindings() {
        window.addEventListener('resize', this.handleResizeFunc);
        if ( window.scrollLib ) {
            window.scrollLib.on('scroll', (event) => {
                if ( this.app && this.app.ticker ) {
                    const { y } = event.scroll;
                    if ( y > window.innerHeight && this.running ) {
                        this.app.ticker.stop();
                        this.running = false;
                    }
                    if ( !this.running && y < window.innerHeight ) {
                        this.app.ticker.start();
                        this.running = true;
                    }
                }
            })
        }
    }

    _removeBinding() {
        window.removeEventListener('resize', this.handleResizeFunc);
    }

    start(id, cb) {
        document.querySelector(`#${id}`).appendChild(this.app.view);
        this._load((resources) => {
            cb();
            this._start(resources);
        });
    }

    onPointerMove(eventData) {
        this.posX = eventData.data.global.x;
        this.posY = eventData.data.global.y;
    }

    _map(n, start1, stop1, start2, stop2) {
        const newval = (n - start1) / (stop1 - start1);
        return newval * (stop2 - start2) + start2;
    }

    del() {
        if ( this.app ) {
            this.app.destroy();
            this._removeBinding();
        }
    }

    /* To test to performance */
    pause() {
        if ( this.app ) {
            this.app.renderer.ticker.stop();
        }
    }
    /* To test to performance */
    unpause() {
        this.app.renderer.ticker.start();
    }

    _applyFilter(spriteBg, mouseBg) {
        this.dpFilter = new this.DisplacementFilter(spriteBg);
        this.dpFilter.scale.x = 20;
        this.dpFilter.scale.y = 20;

        this.dpMouseFilter = new this.DisplacementFilter(mouseBg);
        this.dpMouseFilter.scale.x = 200;
        this.dpMouseFilter.scale.y = 0;


        this.shockFilter = new this.ShockwaveFilter([0, 0], {
            amplitude: 300,
            wavelength: 2000,
        }, 2);

        this.shockFilter.time = 4;
        this.container.filters = [
            this.dpFilter,
            this.shockFilter,
        ];
    }

    _load(cb) {
        this.loader = new this.pixi.Loader();

        this.loader
            .add('bg', this.dataSlider[0].image)
            .add('bgsecond', this.dataSlider[1].image)
            .add('bgthird', this.dataSlider[2].image)
            .add('gradient', Gradient)
            .add('bgback', BgBack)
            .add('bgmouse', BgBackMouse);

        this.loader.load((loader, resources) => cb(resources));

        this.app.stage.interactive = true;
        this.app.stage.sortableOrder = true;

        this.container = new this.pixi.Container();
        this.containerText = new this.pixi.Container();
        this.containerOverlay = new this.pixi.Container();

        this.app.stage.addChild(this.container);
        this.app.stage.addChild(this.containerOverlay);
        this.app.stage.addChild(this.containerText);

        this._createText();

        this.app.stage.on('mousemove', (e) => this.onPointerMove(e));
    }

    _createText() {
        const heroHeight = document.querySelector('.wrapper-container').getBoundingClientRect().height;
        let heroText = '';
        const heroArray = document.querySelectorAll('.wrapper-container h2');
        const vw = window.innerWidth / 2;
        for ( let i = 0 ; i < heroArray.length; i++ ) {
            heroText += heroArray[i].innerHTML.trim() + '\n';
        }
        const sizesText = {
            '1600px': [150, 135, (vw - 675)],
            '1200px': [130, 117, (vw - 525)],
            '600px': [92, 80, 57],
            'default': [50, 54, 15],
        };
        let currentViewport = 'default';
        if ( window.innerWidth > 600 ) {
            currentViewport = '600px';
        }
        if ( window.innerWidth > 1200 ) {
            currentViewport = '1200px';
        }
        if ( window.innerWidth > 1600 ) {
            currentViewport = '1600px';
        }
        const vh = window.innerHeight;
        this.text = new this.pixi.Text(
            heroText,
            {
                fontFamily: 'Work Sans',
                fontSize: sizesText[currentViewport][0],
                fontWeight: 700,
                fill: 0xFFFFFF,
                lineHeight: sizesText[currentViewport][1],
                align: 'left'
            });
        
        this.text.updateText();
        this.text.position.set(sizesText[currentViewport][2], (vh * 0.55) - (heroHeight / 2) - 35);
        if ( window.innerWidth < 1200 ) {
            this.text.position.set(sizesText[currentViewport][2] - 2, (window.innerHeight * 0.55 ) - (heroHeight / 2) - 35);
        }
        this.text.alpha = 1;
        this.containerText.addChild(this.text);

    }

    _createSprite(texture) {
        const sprite = new this.pixi.Sprite(texture);
        sprite.x = 0;
        sprite.y = 0;

        return sprite;
    }

    _addToChild(element, toMain = true) {
        if (toMain) {
            this.container.addChild(element);
            this.imagesContainerArray.push(element);
        } else {
            this.containerOverlay.addChild(element);
        }
    }

    _applyFullscreen(sprite) {
        if (!sprite) { return true; }
        try {
            const vh = window.innerHeight;
            const ratio = sprite.width / sprite.height;

            sprite.anchor.set(0.5, 0.5);

            sprite.x = window.innerWidth / 2;
            sprite.y = window.innerHeight / 2;


            if (window.innerWidth > vh * 1.5) {
                sprite.width = window.innerWidth;
                sprite.height = window.innerWidth / ratio;
            } else {
                sprite.width = vh * ratio;
                sprite.height = vh;

                /// console.log(sprite.width, sprite.height);
            }
        } catch (e) {
            console.log('error:', e);
        }
    }

    _nextSlider() {
        if (this.isRunning) {
            return false;
        }
        this.isRunning = true;
        
        const nextIndex = (this.currIndex + 1) % this.sliders.length;
        const currSlide = this.sliders[this.currIndex];
        const nextSlide = this.sliders[nextIndex];
        const tl = new TimelineLite({ paused: true });
        const obj = {
            opacity: 1,
        }
        let that = this;
        tl.to(obj, 1, {
            opacity: 0,
            onUpdate: () => {
                that.text.alpha = obj.opacity;
            },
            onComplete: () => {
                const nextSlider = this.dataSlider[nextIndex].title;
                that.text.text = nextSlider.split(' ').join('\n');
            }
        })
        .to(obj, 1, {
            opacity: 1,
            onUpdate: () => {
                that.text.alpha = obj.opacity;
            },
        })
        tl.play();
        if (!nextSlide || !currSlide) {
            return false;
        }

        this._makeWave(currSlide, nextSlide, nextIndex);
        
        return true;
    }

    _makeWave(currSlide, nextSlide, nextIndex) {
        const obj = {
            opacityIn: 0,
            opacityOut: 1,
            intensity: 20,
            factor: 1,
        };
        const wave = { time: 0 };
        const tl = new TimelineLite({ paused: true });
        this.shockFilter.center = [
            this.posX,
            this.posY,
        ];
        tl
            .to(obj, 1, {
                opacityIn: 0.5,
                opacityOut: 0.5,
                intensity: 400,
                factor: 0.6,
                ease: Power4.easeIn,
                onUpdate: () => {
                    this.dpFilter.scale.x = obj.intensity;
                    this.dpFilter.scale.y = (obj.intensity - 20) / 10;

                    this.shockFilter.amplitude = obj.opacityIn * 800;
                    currSlide.alpha = obj.opacityOut;
                    nextSlide.alpha = obj.opacityIn;
                },
            })
            .to(obj, 1, {
                opacityIn: 1,
                opacityOut: 0,
                intensity: 20,
                factor: 1,
                ease: Power4.easeOut,
                onUpdate: () => {
                    this.dpFilter.scale.x = obj.intensity;
                    this.dpFilter.scale.y = (obj.intensity - 20) / 10;
                    this.shockFilter.amplitude = obj.opacityOut * 800;
                    currSlide.alpha = obj.opacityOut;
                    nextSlide.alpha = obj.opacityIn;
                },
                onComplete: () => {
                    this.currIndex = nextIndex;
                    this.isRunning = false;
                },
            })
            .to(wave, 2, {
                time: 2,
                ease: Power4.easeInOut,
                onUpdate: () => {
                    this.shockFilter.time = wave.time;
                },
            }, '-=2');
        tl.play();
    }

    _start(resources) {
        const vh = window.innerHeight;

        setInterval(() => this._nextSlider(), 8000);
        const bg = this._createSprite(resources.bg.texture);
        this._addToChild(bg);
        this._applyFullscreen(bg);
        
        const bgSecond = this._createSprite(resources.bgsecond.texture);
        bgSecond.alpha = 0;
        this._addToChild(bgSecond);
        this._applyFullscreen(bgSecond);

        const bgThird = this._createSprite(resources.bgthird.texture);
        bgThird.alpha = 0;
        this._addToChild(bgThird);
        this._applyFullscreen(bgThird);

        const gradientOverlay = this._createSprite(resources.gradient.texture);
        gradientOverlay.anchor.set(0.5,0.5);
        this._addToChild(gradientOverlay, false);
        this._applyFullscreen(gradientOverlay);
        this.text.updateText();
        // console.log('mask ', this.text);
        gradientOverlay.mask = this.text;

        this.gradientOverlay = gradientOverlay;
        this.sliders.push(bg);
        this.sliders.push(bgSecond);
        this.sliders.push(bgThird);

        const bgBackground = this._createSprite(resources.bgback.texture);
        this._addToChild(bgBackground);
        bgBackground.texture.baseTexture.wrapMode = this.pixi.WRAP_MODES.REPEAT;

        const bgBackgroundMouse = this._createSprite(resources.bgmouse.texture);
        // this._addToChild(bgBackgroundMouse);
        bgBackgroundMouse.width = 400;
        bgBackgroundMouse.height = vh;


        this._applyFilter(bgBackground, bgBackgroundMouse);
        
        
        let count = 0;
        
        this._makeWave(this.sliders[0], this.sliders[0], 0);

        this.app.ticker.add(() => {
            // bgBackground.x = count * 10;
            // bgBackground.y = count * 10;
            count += 0.1;
            // bgBackgroundMouse.x = this.posX - 200;

            if ( this.posY < window.innerHeight ) {
                this.gradientOverlay.position.set(this.posX, this.posY);
            }
            /*
            if (this.dpMouseFilter) {
                this.dpMouseFilter.scale.x = 10 + this._map(this.intensity, 0, 500, 0, 120);
            }

            if (this.intensity > 0) {
                this.intensity = Math.abs(this.intensity) - 1;
            }

            */
            if (count > 2) {
                count = 0;
            }
        });
        this.handleResize();
    }
}
